import React, { useState, useRef, useEffect } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import axios from "axios";

const HARDCODED = [
	{
		question: "Apa saja fitur yang tersedia di Jogja Madrasah Digital (JMD)?",
		answer:
			"Jogja Madrasah Digital menyediakan berbagai fitur termasuk presensi online, modul pembelajaran digital, evaluasi dan penilaian, dashboard monitoring, data madrasah terintegrasi, serta portal orang tua cerdas mandiri.",
	},
	{
		question:
			"Bagaimana cara Mendaftar dan menjadi Anggota Platform Jogja Madrasah Digital?",
		answer:
			"Untuk mendaftar, madrasah dapat menghubungi Kanwil Kemenag DIY melalui kontak yang tersedia. Setelah terdaftar, admin madrasah akan mendapatkan akses untuk mengelola data guru dan siswa.",
	},
	{
		question: "Apakah Jogja Madrasah Digital bisa diakses secara gratis?",
		answer:
			"Ya, Jogja Madrasah Digital dapat diakses secara gratis untuk madrasah-madrasah di wilayah D.I. Yogyakarta yang telah terdaftar melalui Kanwil Kemenag DIY.",
	},
	{
		question: "Apa yang ditampilkan dalam halaman dari Jogja Madrasah Digital?",
		answer:
			"Halaman Jogja Madrasah Digital menampilkan informasi tentang program digitalisasi madrasah, berita terbaru, fitur-fitur platform, galeri kegiatan, serta informasi kontak dan FAQ.",
	},
	{
		question: "Apakah ada pelatihan untuk menggunakan Jogja Madrasah Digital?",
		answer:
			"Ya, Kanwil Kemenag DIY secara rutin mengadakan pelatihan dan sosialisasi untuk guru dan tenaga kependidikan dalam menggunakan platform Jogja Madrasah Digital.",
	},
];

function FAQ() {
	const [openIndex, setOpenIndex] = useState(null);
	const [isVisible, setIsVisible] = useState(false);
	const [faqs, setFaqs] = useState(HARDCODED);
	const [sectionTitle, setSectionTitle] = useState(
		"Pertanyaan yang Sering Diajukan"
	);
	const sectionRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) setIsVisible(true);
			},
			{ threshold: 0.15 }
		);
		if (sectionRef.current) observer.observe(sectionRef.current);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		axios
			.get("/api_w/faqs", {
				headers: { db_name: process.env.REACT_APP_DB_NAME },
			})
			.then((res) => {
				const items = res.data.data;
				if (items?.length) {
					const mapped = items.map((f) => ({
						question: f.question,
						answer: f.answer,
					}));
					setFaqs(mapped);
				}
			})
			.catch(() => {});
	}, []);

	return (
		<section aria-label="FAQ" ref={sectionRef} className="py-20 px-4 md:px-20 bg-white">
			<div className="max-w-8xl mx-auto">
				<div className="mb-12">
					<h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
						{sectionTitle}
					</h2>
					<p className="text-gray-500 text-sm md:text-base">
						Temukan jawaban dari pertanyaan yang sering ditanyakan tentang
						ekosistem Jogja Madrasah Digital
					</p>
				</div>

				<div className="space-y-4">
					{faqs.map((faq, idx) => (
						<div
							key={idx}
							className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 border ${
								openIndex === idx
									? "border-green-500 shadow-xl ring-1 ring-green-100"
									: "border-gray-100 shadow-sm"
							} ${isVisible ? "animate-fade-in-up opacity-100" : "opacity-0"}`}
							style={{ animationDelay: `${idx * 0.1}s` }}
						>
							<button
								onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
								className="w-full flex items-center justify-between p-6 text-left"
							>
								<div className="flex gap-4 items-center">
									<span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-50 flex items-center justify-center text-green-700 font-bold text-sm">
										{idx + 1}.
									</span>
									<span className="font-bold text-gray-800 text-sm md:text-base">
										{faq.question}
									</span>
								</div>
								<ChevronDownIcon
									className={`w-5 h-5 text-gray-400 transition-transform duration-300 ${openIndex === idx ? "rotate-180 text-green-600" : ""}`}
								/>
							</button>
							<div
								className={`overflow-hidden transition-all duration-500 ${openIndex === idx ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
							>
								<div className="px-6 pb-6 ml-12 text-gray-600 text-sm md:text-base leading-relaxed">
									{faq.answer}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default FAQ;
